module.exports = __webpack_public_path__ + "static/media/5.6be6ed86.jpg";